import React, { useCallback, useEffect, useState } from "react"
import { useTextWithBreaksContext } from "../index"
import { findItemIndex, getStoryItems, updateStoryItem } from "../utils"
import { RowWrapper } from "../Components"
import Paragraph from "../Paragraph"
import { gsap, useGSAP } from "@repo/utils/gsap"

export const HOVER_VARIANTS = {
	CLICKED: "clicked",
	HOVER: "hover",
	MOVE: "move",
	NONE: "",
}

function checkIfGroupItemWasClickedBefore(group = {}, index = -1) {
	return group?.indexes?.includes(index) || false
}
function getExistingGroup(parentId = "") {
	const storageItems = getStoryItems()
	return storageItems.find((item) => item.id === parentId)
}
function resetHoverArray(row = [], parentId = "", texts = []) {
	const existingGroup = getExistingGroup(parentId)
	return row.map((item, index) => {
		const currIndex = findItemIndex(index, row, texts)
		const clickedBefore = checkIfGroupItemWasClickedBefore(existingGroup, currIndex)
		return clickedBefore ? HOVER_VARIANTS.CLICKED : HOVER_VARIANTS.NONE
	})
}

function handleLeaveHoverArray(row = [], hoveredIndex = -1, parentId = "", texts = []) {
	const existingGroup = getExistingGroup(parentId)
	const textIndex = findItemIndex(hoveredIndex, row, texts)
	const clickedBefore = checkIfGroupItemWasClickedBefore(existingGroup, textIndex)
	return row.map((item, index) => {
		if (!clickedBefore) return HOVER_VARIANTS.NONE
		//if item was clicked already leave hovered state in the hover array
		return index === hoveredIndex ? HOVER_VARIANTS.CLICKED : HOVER_VARIANTS.NONE
	})
}

function handleEnterHoverArray(row = [], hoveredIndex = -1, parentId = "", texts = []) {
	const existingGroup = getExistingGroup(parentId)
	return row.map((item, index) => {
		if (index === hoveredIndex) return "hover"
		const currIndex = findItemIndex(index, row, texts)
		const currClickedBefore = checkIfGroupItemWasClickedBefore(existingGroup, currIndex)
		const fallback = index > hoveredIndex ? HOVER_VARIANTS.MOVE : HOVER_VARIANTS.NONE
		// console.log(item);
		return currClickedBefore ? HOVER_VARIANTS.CLICKED : fallback
	})
}

const Row = ({ data, left, parentId = "", imageLoadPriority = false, index: rowIndex = 0 }) => {
	const [hoverArray, setHoverArray] = useState([])
	const breaks = useTextWithBreaksContext("breaks")
	const { contextSafe } = useGSAP()

	// useEffect(() => {
	//     console.log(hoverArray);
	// },[hoverArray])

	useEffect(() => {
		setHoverArray(resetHoverArray(data, parentId, breaks.texts))
	}, [data, parentId, breaks])

	const handlePointerEnter = useCallback(
		(hoveredIndex) => {
			setHoverArray(handleEnterHoverArray(data, hoveredIndex, parentId, breaks.texts))
		},
		[data, parentId, breaks],
	)

	const handlePointerLeave = useCallback(
		(hoveredIndex) => {
			setHoverArray(handleLeaveHoverArray(data, hoveredIndex, parentId, breaks.texts))
		},
		[data, parentId, breaks],
	)

	//creates visual bugs on rapid & frequent clicking
	const animateTopRowButton = contextSafe(() => {
		const topRowIcon = document.getElementById("top-row-story-button")
		if (!topRowIcon) return
		const tl = gsap.timeline({ paused: true })
		tl.to(topRowIcon, {
			duration: 0.2,
			boxShadow: "0 0 2px 4px #041B28",
			scale: 1.35,
			ease: "none",
			onComplete: () => {
				tl.reverse()
			},
		})
		tl.play()
	})

	const handleOnClick = useCallback(
		(clickedIndex) => {
			// animateTopRowButton()
			setHoverArray(handleEnterHoverArray(data, clickedIndex, parentId, breaks.texts))
			updateStoryItem(parentId, clickedIndex, data, breaks.texts)
		},
		[parentId, data, breaks],
	)

	return (
		<RowWrapper $left={left} className="row">
			{data.map((item, index) => (
				<Paragraph
					key={`${item.text}-${index}`}
					index={index}
					text={item.text}
					hover={hoverArray[index]}
					onPointerEnter={handlePointerEnter}
					onPointerLeave={handlePointerLeave}
					onClick={handleOnClick}
					left={left}
					imageLoadPriority={imageLoadPriority}
					breakId={item.breakId}
					rowIndex={rowIndex}
				/>
			))}
		</RowWrapper>
	)
}

export default Row
